const countyConfigEscrowReducer = (state = [{}], action) => {
  switch (action.type) {
    case 'LANDSHARK_COUNTY_CONFIG_ESCROW':
      return action.results;
    default:
      break;
  }
  return state;
}

export default countyConfigEscrowReducer;